<ngx-loading [show]="loading"></ngx-loading>
<div class="edit-container position-absolute d-block z-index-3 white-background">
  <div class="re-links-container" kendoTooltip tooltipClass="em-tooltip" position="top">
    <div class="re-links">
      <button class="btn em-btn" (click)="cancelUpdate()">
        <i class="far fa-times" aria-hidden="true" title="Close Panel"></i>
      </button>
    </div>
  </div>
  <div class="row teal-background">
    <div class="col">
      <h6 class="white-font uppercase p-2 mb-0">Edit Provider</h6>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="row mx-0 mt-2">
      <div class="col px-2">
        <mat-form-field class="w-100">
          <input
            matInput
            placeholder="Provider Name Reference"
            class="capitalized"
            aria-label="Provider Name Reference"
            [value]="provider?.title"
            [disabled]="true"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div class="col px-2">
        <mat-form-field class="w-100">
          <input
            matInput
            placeholder="Online Name"
            class="capitalized"
            aria-label="Online Name"
            formControlName="onlineBookingProviderName"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="teal-background">
      <h6 class="white-font uppercase p-2 mb-0">Online Booking Availability</h6>
    </div>
    <div class="d-flex align-items-center teal-font mt-2 ml-2">
      <label class="switch mb-0">
        <input #overrideClinicSchedule type="checkbox" formControlName="useOnlineBookingHours" />
        <span class="slider round"></span>
      </label>
      <ng-template #helpTemplate>
        Online booking availability for this provider will be based on the schedule below and applied within their
        clinic schedule.
      </ng-template>
      <span class="pl-2"
        ><div kendoTooltip [tooltipTemplate]="helpTemplate" filter="i" position="right">
          Override Clinic Schedule&nbsp;
          <i class="fa fa-question-circle teal-font"></i></div
      ></span>
    </div>
    <div class="row mx-0 mt-2" formGroupName="onlineBookingHours">
      <div></div>
      <div class="item-row">
        <div class="closed-column">None</div>
        <div class="day-of-week-column">Day of Week</div>
        <div class="start-end-time-column">Start Time</div>
        <div class="start-end-time-column">End Time</div>
      </div>

      <ng-container *ngFor="let day of weekDays | keyvalue : originalOrder">
        <ng-container *ngTemplateOutlet="dayOfWeek; context: { formDay: day.key, day: day.value }"></ng-container>
      </ng-container>

      <ng-template #dayOfWeek let-formDay="formDay" let-day="day">
        <div class="item-row" formGroupName="{{ formDay }}">
          <div class="closed-column"><mat-checkbox formControlName="closed"></mat-checkbox></div>
          <div class="day-of-week-column">{{ day }}</div>
          <div class="start-end-time-column">
            <kendo-timepicker
              name="startTime"
              [min]="dayMinMaxHours[formDay].min"
              [max]="dayMinMaxHours[formDay].max"
              [steps]="{ minute: 5 }"
              [readOnlyInput]="true"
              formControlName="openTime"
            ></kendo-timepicker>
          </div>
          <div class="start-end-time-column">
            <kendo-timepicker
              name="endTime"
              [min]="dayMinMaxHours[formDay].min"
              [max]="dayMinMaxHours[formDay].max"
              [steps]="{ minute: 5 }"
              [readOnlyInput]="true"
              formControlName="closeTime"
            ></kendo-timepicker>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="row mx-0 mt-2">
      <div class="col px-2 text-center">
        <button class="btn em-btn em-btn-green" (click)="updateProvider()" [disabled]="this.form.pristine">
          Update
        </button>
      </div>
      <div class="col px-2 text-center">
        <button class="btn em-btn em-btn-green" (click)="cancelUpdate()">Cancel</button>
      </div>
    </div>
  </form>
</div>
